export const fieldValue = {
    Name: 'Name',
    Type: 'corp',
    Role: 'ceo',
    Address1: 'Address1',
    Address2: 'Address2',
    City: 'City',
    State: 'State',
    Zip: 'Zip',
    Phone1: 'Phone1',
    URL: 'URL',
    NAICS: 'NAICS',
  }
  
  export var completeCompany = {
      companyName: fieldValue.Name,
      companyType: fieldValue.Type,
      companyRole: fieldValue.Role,
      companyAddress1: fieldValue.Address1,
      companyAddress2: fieldValue.Address2,
      companyCity: fieldValue.City,
      companyState: fieldValue.State,
      companyZip: fieldValue.Zip,
      companyPhone1: fieldValue.Phone1,
      companyURL: fieldValue.URL,
      companyNAICS: fieldValue.NAICS,
  }
  
  export var missingAllRequiredCompany = {
    companyAddress2: fieldValue.Address2,
    companyPhoneNumber2: fieldValue.PhoneNumber2,
    companyURL: fieldValue.URL,
  }
  
export default completeCompany